const separator = {
  1: '.',
  3: ' ',
  11: '.',
  15: ' ',
  18: '.',
};

const currencySign = {
  1: ':-',
  3: ',—',
  11: ',-',
  15: ',-',
  18: ':-',
};

const formatPrice = (price, siteId, roundUp = false) => {
  const trimmed = roundUp ? Math.ceil(price || 0) : Math.floor(price || 0);
  const priceString = trimmed.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${separator[siteId]}`);
  return `${priceString}${currencySign[siteId]}`;
};

export default formatPrice;
